import './IconInteractiveMap.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconInteractiveMap = function IconInteractiveMap(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23.056",
    height: "19.782",
    viewBox: "0 0 23.056 19.782",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M21.856,5.319V3.362a.367.367,0,0,0-.218-.331l-7.044-3a.367.367,0,0,0-.286,0L7.4,2.955,4.134,1.576.513.031A.363.363,0,0,0,.3.008.364.364,0,0,0,0,.371V15.22a.367.367,0,0,0,.218.331l7.045,3a.362.362,0,0,0,.285,0l6.906-2.926,3.268,1.38,3.62,1.545a.363.363,0,0,0,.216.023.364.364,0,0,0,.3-.364V5.319ZM7.764,14.452a.371.371,0,0,0,.011-.055V7.868H7.692a.648.648,0,0,0-.648.648V8.6s0,.008,0,.013l-.016,9.046-6.3-2.693V.936L3.689,2.182,7.044,3.612V5.588h0v.1h.083a.648.648,0,0,0,.648-.648V3.613l6.037-2.559L13.8,1.035,14.1.91l-.006,3.22a.415.415,0,0,0-.011.055V8.117h.083a.648.648,0,0,0,.648-.648V7.38s0-.008,0-.013L14.828.919l6.3,2.693V17.646L18.168,16.4,14.811,14.97V10.4h0v-.1h-.083a.649.649,0,0,0-.648.648V14.97L8.044,17.529l.009.019-.294.125Z",
    transform: "translate(0.6 0.6)",
    "stroke-width": "1.2"
  }));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s161xdsn"
});
export default IconInteractiveMap;